import { ReactQueryV5 } from "@mindlercare/mindlerapi-client";
const { useQuery } = ReactQueryV5;
import { useFlag } from "@mindlercare/unleash-client";
import CONSTANTS from "core/constants";
import { getTemplateLabel } from "core/functions/template";
import useMarketStrategy from "strategies/market/useMarketStrategy";
import { useMindlerApi } from "../api/apiv2";
import { type First } from "helpers/arrays";

export const useTemplates = () => {
  const api = useMindlerApi();
  const res = useQuery(
    api.slots.templates.getAll.queryOptions(undefined, { staleTime: Infinity }),
  );

  return { ...res, data: res.data ?? [] };
};

export const useSelectedTemplates = () => {
  const { data: templates } = useTemplates();
  const fullPsySchedule = useFlag("PSYCHOLOGIST_FULL_SCHEDULE");

  const strategy = useMarketStrategy();
  const isEHealthEnabled = useFlag("E_HEALTH_SLOT");
  const isAdhdScreeningEnabled = useFlag("ADHD_SCREENING_SLOT");
  const templatesToDisplay = templates.filter((template) => {
    if (
      template.name === CONSTANTS.SLOT_TEMPLATES.DIAGNOSTICS_JOURNAL_ENTRY &&
      !isEHealthEnabled
    ) {
      return false;
    }
    if (
      template.name === CONSTANTS.SLOT_TEMPLATES.ADHD_SCREENING &&
      !isAdhdScreeningEnabled
    ) {
      return false;
    }

    return template.enabled && strategy.slotTemplates.includes(template.name);
  });

  return templatesToDisplay
    ?.map((template) => {
      return {
        ...template,
        value: template.name,
        label: getTemplateLabel(
          template,
          templates,
          strategy.showRevisitLabelSuffix,
          fullPsySchedule,
        ),
      };
    })
    .sort((a, b) => a.label.localeCompare(b.label));
};

export type SelectedTemplate = First<ReturnType<typeof useSelectedTemplates>>;
